import { render, staticRenderFns } from "./p3s6AccountSetupTermsOfService.vue?vue&type=template&id=04b32449"
import script from "./p3s6AccountSetupTermsOfService.vue?vue&type=script&lang=js"
export * from "./p3s6AccountSetupTermsOfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports